<mat-card class="object-name-search-card">

  <div *ngIf="!objects" class="row"
       style="margin: 80px">
    <div class="fill-space"></div>
    <div>
      <div class="row">
        <div class="fill-space"></div>
        <div>
          <mat-spinner></mat-spinner>
        </div>
        <div class="fill-space"></div>
      </div>
      <div class="row">
        <div class="fill-space"></div>
        <div style="margin-top: 20px;">
          Henter objektliste...
        </div>
        <div class="fill-space"></div>
      </div>
    </div>
    <div class="fill-space"></div>
  </div>
  <div class="row" *ngIf="objects">
    <div class="fill-space"></div>
    <div style="align-items: center; display: flex; flex-direction: column; width: 100%;">
      <span style="margin-bottom: 5px;">
        <mat-spinner *ngIf="!objects"
                     [diameter]="20"
                     [strokeWidth]="2"
                     style="display: inline-block; vertical-align: middle;"
        ></mat-spinner>
        <p-badge *ngIf="objects.length > 0" [value]="objects.length + ' objekt' + (objects.length === 1 ? '' : 'er')"
                 [style]="objects.length === 0 ? { 'background-color': '#ffd63f', 'color': '#333' } : { 'background': 'none', 'color': '#ccc' }"></p-badge>
        </span>
      <app-empty-list *ngIf="objects && objects.length === 0"
                      message="Ingen {{ key.label }}{{ key.value === 'name' ? '' : ' tag' }} funnet i prosjektet"></app-empty-list>
      <div *ngIf="objects.length > 0" class="hint">Hint: {{ hint }}</div>
      <div *ngIf="objects.length > 0 && key" style="width: 100%; height: 100%">
        <ng-container *ngIf="recreateListbox">
          <p-listbox
            [options]="objectsGroupedByType"
            optionGroupLabel="label"
            optionGroupChildren="items"
            group="true"
            [emptySelectionMessage]="'Ingen ' + key.label + ' funnet'"
            [(ngModel)]="selectedObject"
            [optionLabel]="key.value"
            [filter]="true"
            [filterBy]="'items.' + key.value"
            [filterPlaceHolder]="'Søk etter ' + key.label + (key.value === 'name' ? '' : ' tag')"
            [listStyle]="listStyle"
            [scrollHeight]="'calc(100vh - 360px)'"
            [virtualScroll]="true"
            [virtualScrollItemSize]="38"
            (onClick)="itemSelected($event)"
          >
            <ng-template let-group pTemplate="group">
              <div>
                <mat-icon color="primary" style="margin-bottom: -6px;">scatter_plot</mat-icon>
                <span style="font-size: 16px; color: #398e3c">{{ group.label }}</span>
              </div>
            </ng-template>
            <ng-template let-object pTemplate="item">
              <div *ngIf="key.value === 'name'">{{ object[key.value] }}</div>
              <div *ngIf="key.value !== 'name'">
                <p-tag [value]="key.label" severity="warning"
                       [style]="{
                     'margin-right': '-10px',
                     'padding-right': '17px',
                     'background-color': '#555',
                     'color': '#ccc'
                     }"></p-tag>
                <p-tag [style]="{ 'font-size': '11px' }" icon="pi pi-tag" [value]="object[key.value]"
                       severity="warning"></p-tag>
              </div>
              <p-tag [style]="{
                      'margin-left': '8px',
                       'font-size': '8px',
                       'background-color': '#306232',
                       'color': '#ccc'
                     }"
                     [value]="object.type?.name">
              </p-tag>
            </ng-template>
          </p-listbox>
        </ng-container>
      </div>
    </div>
    <div class="fill-space"></div>
  </div>
</mat-card>
